import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-menu',
  templateUrl: './modal-menu.component.html',
  styleUrls: ['./modal-menu.component.css']
})
export class ModalMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
